import "@babel/polyfill";
import Vue, { VNode } from "vue";
import "./plugins/axios";
import "./plugins/vuetify";
import "./plugins/validation";
import "./plugins/filters";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h: any): VNode => h(App)
}).$mount("#app");
